import { render, staticRenderFns, recyclableRender, components } from "./visitorApproval.vue?vue&type=template&id=7542a4aa&scoped=true&"
var renderjs
import script from "./visitorApproval.vue?vue&type=script&lang=js&"
export * from "./visitorApproval.vue?vue&type=script&lang=js&"
import style0 from "./visitorApproval.vue?vue&type=style&index=0&lang=css&"
import style1 from "./visitorApproval.vue?vue&type=style&index=1&id=7542a4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7542a4aa",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/visitorApproval/visitorApproval.vue"
export default component.exports